import { Component, EventEmitter, Input, Output, OnDestroy, OnInit } from '@angular/core';
import { Idle } from './idle';
import { Http } from '@angular/http';
import { Headers } from '@angular/http';

import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';


@Component({
	selector: 'app-reload',
	template: '',
})

export class AppReloadDirective implements OnInit, OnDestroy {
	@Input() maxIdle: string;
	@Input() forceTimeout: string;
	@Output() onChange: EventEmitter<string> = new EventEmitter<string>();

	private idle: Idle;
	private timeout: any;

	delay: number = 3000; //max delay after retry

	constructor(private http: Http) {
	}

	ngOnInit() {
		if (!this.maxIdle) {
			this.maxIdle = (60 * 5).toString() // default 5min
		}
		if (!this.forceTimeout) {
			this.forceTimeout = (1000 * 60 * 60 * 5).toString() // default 5hour;
		}

		this.idle = new Idle()
			.whenNotInteractive()
			.within(parseInt(this.maxIdle), 1000)
			.do(() => {

				this.doAppVersion();

				this.idle.restart();

				this.startForceTimeout();
			})
			.start();

		console.log(this.forceTimeout);
		this.startForceTimeout();
	}

	ngOnDestroy() {
		this.idle.stop();
		this.removeForceTimeout();
	}

	removeForceTimeout() {
		clearTimeout(this.timeout);
	}

	startForceTimeout() {
		this.removeForceTimeout();

		let t = parseInt(this.forceTimeout) * 1000
		this.timeout = setTimeout(() => {
			console.log('force timeout', t);

			this.doAppVersion();

			this.startForceTimeout();

		}, t);
	}

	appVersion(): Observable<string> {
		console.log('app version');
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		return this.http.get('/app-version.json', { headers: headers })
			.timeout(10000)
			.retryWhen(error => this.httpRetry(error))
			.map(resp => {
				if (resp.status == 200) {
					return resp.json().version;
				} else {
					throw new Error('error when getting app-version.json');
				}
			});
	}

	doAppVersion() {

		this.appVersion()
			.catch(err => {
				console.log(err);
				return Observable.of('');
			})
			.do((v: string) => {
				if (v !== '') {
					this.onChange.emit(v);
				}
			})
			.subscribe(() => {
			}, err => {
				console.log(err);
			});
	}

	httpRetry(o: Observable<any>): Observable<any> {
		return o
			.flatMap((error: any) => {
				return Observable.of(error).delay(this.delay);
			})
			.take(5)
			.concat(Observable.throw({error: 'error when getting app-version.json'}));
	}
}
